import { Router } from '@angular/router';
import { HotjarService } from './../../auth-module/services/hotjarService';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import * as unitActions from '../actions/unit';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { UnitService } from '../services/unit';
import { Action } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { FacebookService } from '../../lib/services';
import { Unit } from '../models/unit';
import { Page } from '../../lib/classes/page';
import { UnitEmployment } from '../models/unitEmployment';

@Injectable()
export class UnitsEffects {
  @Effect()
  loadUnits$: Observable<Action> = this.actions$.pipe(
    ofType<unitActions.LoadUnits>(unitActions.ActionTypes.LoadUnits),
    switchMap(action =>
      this.unitService.getUnitsTree(action.payload.id).pipe(
        map((response: Unit) => {
          if (response) {
            return new unitActions.LoadUnitsSuccess({
              units: [response],
              focusParent: action.payload.focusParent
                ? action.payload.focusParent
                : false,
            });
          } else {
            this._router.navigate(['login']);
          }
        }),
        tap((res: any) => {
          // this._handleUnits(res.payload.userUnits);
        }),
        catchError(errors => {
          // this._router.navigate(['login']);
          console.error('fail?', errors);
          return of(new unitActions.LoadUnitsFail({ errors }));
        })
      )
    )
  );

  @Effect()
  UpdateUnit$: Observable<Action> = this.actions$.pipe(
    ofType<unitActions.UpdateUnit>(unitActions.ActionTypes.UpdateUnit),
    switchMap(action =>
      this.unitService.updateUnit(action.payload.unit).pipe(
        switchMap((unit: Unit) => [
          new unitActions.UpdateUnitSuccess({
            unit,
          }),
          new unitActions.LoadUnits({ id: this._getUnitId() }),
        ]),
        catchError(errors => of(new unitActions.LoadUnitsFail({ errors })))
      )
    )
  );

  @Effect()
  LoadUnit$: Observable<Action> = this.actions$.pipe(
    ofType<unitActions.LoadUnit>(unitActions.ActionTypes.LoadUnit),
    switchMap(action =>
      this.unitService.getUnit(action.payload.unit.id).pipe(
        map((unit: Unit) => new unitActions.LoadUnitSuccess({ unit })),
        catchError(errors => of(new unitActions.LoadUnitsFail({ errors })))
      )
    )
  );

  @Effect()
  LoadUsers: Observable<Action> = this.actions$.pipe(
    ofType<unitActions.LoadUnitUsers>(unitActions.ActionTypes.LoadUnitUsers),
    switchMap(action =>
      this.unitService.getUnitUsers(action.payload.id).pipe(
        map(
          (users: Page<Array<any>>) =>
            new unitActions.LoadUnitUsersSuccess({
              users: users.results,
            })
        ),
        catchError(errors => of(new unitActions.LoadUnitsFail({ errors })))
      )
    )
  );

  @Effect()
  UpdateUnitEmployment$: Observable<Action> = this.actions$.pipe(
    ofType<unitActions.UpdateUnitEmployment>(
      unitActions.ActionTypes.UpdateUnitEmployment
    ),
    switchMap(action =>
      this.unitService.updateUnitEmployment(action.payload.unitEmployment).pipe(
        map(
          (unitEmployment: UnitEmployment) =>
            new unitActions.UpdateUnitEmploymentSuccess({
              unitEmployment,
            })
        ),
        catchError(httpError =>
          of(
            new unitActions.UnitEmploymentError({
              error:
                Object.keys(httpError.error)[0] +
                ': ' +
                httpError.error[Object.keys(httpError.error)[0]],
            })
          )
        )
      )
    )
  );

  @Effect()
  DeleteUnitEmployment$: Observable<Action> = this.actions$.pipe(
    ofType<unitActions.DeleteUnitEmployment>(
      unitActions.ActionTypes.DeleteUnitEmployment
    ),
    switchMap(action =>
      this.unitService.deleteUnitEmployment(action.payload.unitEmployment).pipe(
        switchMap(() => [
          new unitActions.DeleteUnitEmploymentSuccess(
            action.payload.unitEmployment
          ),
          new unitActions.LoadUnits({ id: this._getUnitId() }),
        ]),
        catchError(httpError =>
          of(
            new unitActions.UnitEmploymentError({
              error:
                Object.keys(httpError.error)[0] +
                ': ' +
                httpError.error[Object.keys(httpError.error)[0]],
            })
          )
        )
      )
    )
  );

  @Effect()
  DeleteUnit$: Observable<Action> = this.actions$.pipe(
    ofType<unitActions.DeleteUnit>(unitActions.ActionTypes.DeleteUnit),
    switchMap(action =>
      this.unitService.deleteUnit(action.payload.unitId).pipe(
        switchMap(() => [
          new unitActions.DeleteUnitSuccess(null),
          new unitActions.LoadUnits({
            id: this._getUnitId(),
            focusParent: true,
          }),
        ]),
        catchError(httpError =>
          of(
            new unitActions.UnitActionError({
              error:
                Object.keys(httpError.error)[0] +
                ': ' +
                httpError.error[Object.keys(httpError.error)[0]],
            })
          )
        )
      )
    )
  );

  _handleUnits(units) {
    this._hotjarService.vpv('/auth_component/auth_redirect_success');
    (<any>window).gtag('config', environment.googleAnalyticsTrackingId, {
      page_path: '/auth_redirect_success',
    });
    (<any>window).gtag('event', 'screen_view', {
      app_name: 'business.mojob.io',
      screen_name: '/auth_redirect_success',
    });
    this._facebookService.trackFacebookAnalyticsEvent(
      'comp_register_confirm_mail'
    );
    const office_id = units[0].office.id;
    const comp = localStorage.getItem('comp');
    const company = localStorage.getItem('company');
    const office_name = localStorage.getItem('office_name');
    if (!comp) {
      localStorage.setItem('comp', '' + office_id);
    }
    if (!company) {
      localStorage.setItem('company', '' + units[0].office.company.id);
    }
    if (!office_name) {
      localStorage.setItem('office_name', '' + units[0].office.name);
    }
  }

  _getUnitId(): number {
    // tslint:disable-next-line:radix
    return parseInt(localStorage.getItem('unit_id'));
  }

  constructor(
    private actions$: Actions,
    private unitService: UnitService,
    private _hotjarService: HotjarService,
    private _facebookService: FacebookService,
    private _router: Router
  ) {}

  getCompanyId() {
    return Number(localStorage.getItem('unit_id'));
  }
}
